<header class="encabezado" [class.scrolled]="isScrolled">
  <nav class="barra-navegacion">
    <!-- Botón hamburguesa para móviles -->
    <button class="menu-hamburguesa" id="menuHamburguesa" (click)="toggleMobileMenu()">
      <span class="linea"></span>
      <span class="linea"></span>
      <span class="linea"></span>
    </button>
    
    <ul class="enlaces-principales enlaces-izquierda">
      <li><a routerLink="/nosotros" routerLinkActive="active">Nosotros</a></li>
      <li class="desplegable" (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()" (click)="toggleDropdownDesktop($event)">
        <a routerLink="/servicios" class="enlace-desplegable">
          Servicios 
          <span class="flecha" [class.activa]="isDropdownOpen">
            <img src="assets/svg/weui_arrow-filled.svg" alt="flecha">
          </span>
        </a>
      </li>
    </ul>
    
    <div class="logotipo">
      <a routerLink="/">
        <img src="assets/svg/Logo - Rehobot completo.svg" alt="REHOBOT Logo" width="120" height="40">
      </a>
    </div>
    
    <ul class="enlaces-principales enlaces-derecha">
      <li><a routerLink="/productos" routerLinkActive="active">Productos</a></li>
      <li><a routerLink="/portafolio" routerLinkActive="active">Portafolio</a></li>
    </ul>
    
    <div class="boton-contacto" id="btnContacto">
      <a routerLink="/contacto">
        <button>Contacto</button>
      </a>
    </div>
  </nav>
  
  <!-- Menú lateral para móviles -->
  <div class="menu-lateral" id="menuLateral" [class.activo]="isMobileMenuOpen">
    <div class="contenido-menu">
      <ul class="enlaces-menu">
        <li><a routerLink="/nosotros" (click)="closeMobileMenu()">Nosotros</a></li>
        <li class="desplegable-movil">
          <a routerLink="/servicios" class="enlace-servicios-movil" (click)="toggleServiciosSubmenu($event)">
            Servicios <span class="flecha-movil">▼</span>
          </a>
          <ul class="submenu-servicios" [class.activo]="isServiciosSubmenuOpen">
            <li class="submenu-header">
              <a href="#" class="btn-regresar" (click)="closeServiciosSubmenu($event)">
                <span class="flecha-regresar">◀</span>
                <span>Servicios</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/servicios']" [queryParams]="{ id: 1 }" (click)="closeMobileMenu()">
                <img src="assets/svg/diseño-perforacion-pozos-recurso.svg" alt="Diseño y Perforación" class="icono-servicio-mini">
                Diseño y Perforación de Pozos Subterráneos
              </a>
            </li>
            <li>
              <a [routerLink]="['/servicios']" [queryParams]="{ id: 2 }" (click)="closeMobileMenu()">
                <img src="assets/svg/instalaciones-electromecanicas.svg" alt="Instalaciones Electromecánicas" class="icono-servicio-mini">
                Instalaciones Electromecánicas Automatizadas
              </a>
            </li>
            <li>
              <a [routerLink]="['/servicios']" [queryParams]="{ id: 3 }" (click)="closeMobileMenu()">
                <img src="assets/svg/instalaciones-electricas.svg" alt="Instalaciones Eléctricas" class="icono-servicio-mini">
                Instalaciones Eléctricas y Sistemas de Control
              </a>
            </li>
            <li>
              <a [routerLink]="['/servicios']" [queryParams]="{ id: 4 }" (click)="closeMobileMenu()">
                <img src="assets/svg/fabricacion-instalacion-mantenimiento-tableros.svg" alt="Fabricación de Tableros" class="icono-servicio-mini">
                Fabricación, Instalación y Mantenimiento de Tableros Eléctricos
              </a>
            </li>
          </ul>
        </li>
        <li><a routerLink="/productos" (click)="closeMobileMenu()">Productos</a></li>
        <li><a routerLink="/portafolio" (click)="closeMobileMenu()">Portafolio</a></li>
        <li><a routerLink="/contacto" (click)="closeMobileMenu()">Contacto</a></li>
      </ul>
    </div>
  </div>
  
  <!-- Overlay -->
  <div class="overlay-menu" id="overlayMenu" [class.activo]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>
</header>

  <div class="contenido-desplegable" 
    [class.activo]="isDropdownOpen"
    (mouseenter)="showDropdown()" 
    (mouseleave)="hideDropdown()">
    <a [routerLink]="['/servicios']" [queryParams]="{ id: 1 }" class="elemento-desplegable" (click)="hideDropdown()">
    <div class="icono">
      <img src="assets/svg/diseño-perforacion-pozos-recurso.svg" alt="Diseño y Perforación de Pozos">
    </div>
    <div class="contenido">
      <h4>Diseño y Perforación de Pozos Subterráneos</h4>
    </div>
  </a>
  <div class="separador"></div>
    <a [routerLink]="['/servicios']" [queryParams]="{ id: 2 }" class="elemento-desplegable" (click)="hideDropdown()">
    <div class="icono">
      <img src="assets/svg/instalaciones-electromecanicas.svg" alt="Instalaciones Electromecánicas">
    </div>
    <div class="contenido">
      <h4>Instalaciones Electromecánicas Automatizadas</h4>
    </div>
  </a>
  <div class="separador"></div>
    <a [routerLink]="['/servicios']" [queryParams]="{ id: 3 }" class="elemento-desplegable" (click)="hideDropdown()">
    <div class="icono">
      <img src="assets/svg/instalaciones-electricas.svg" alt="Instalaciones Eléctricas">
    </div>
    <div class="contenido">
      <h4>Instalaciones Eléctricas y Sistemas de Control</h4>
    </div>
  </a>
  <div class="separador"></div>
    <a [routerLink]="['/servicios']" [queryParams]="{ id: 4 }" class="elemento-desplegable" (click)="hideDropdown()">
    <div class="icono">
      <img src="assets/svg/fabricacion-instalacion-mantenimiento-tableros.svg" alt="Tableros Eléctricos">
    </div>
    <div class="contenido">
      <h4>Fabricación, Instalación y Mantenimiento de Tableros Eléctricos</h4>
    </div>
  </a>
</div>
